import { createSlice } from "@reduxjs/toolkit";
import { uploadDoctorStampSignature } from "../../reducer/uploadDoctorStampSignature/uploadDoctorStampSignatureReducer";

const initialState = {
  loading: false,
  data: null,
  error: null,
};

const uploadDoctorStampSignatureSlice = createSlice({
  name: "uploadDoctorStampSignature",
  initialState,
  reducers: {
    resetUploadDoctorStampSignature: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(uploadDoctorStampSignature.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(uploadDoctorStampSignature.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(uploadDoctorStampSignature.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetUploadDoctorStampSignature } =
  uploadDoctorStampSignatureSlice.actions;

export default uploadDoctorStampSignatureSlice.reducer;
